<template>
  <div class="rj-col-3">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        币种<span v-if="required" class="required">*</span>：
      </div>
      <div class="rj-baseinfo__item">
        <el-form-item prop="currencyId">
          <el-select ref="taxType" v-model="form.currencyId" placeholder="请选择币种" style="width:100%;" @change="changetaxType">
            <el-option v-for="(item,index) in moneyType" :key="index" :label="item.name" :value="item.code" />
          </el-select>
        </el-form-item>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { getCurrencyList } from '@/API/international';
import { mapState } from 'vuex';
export default {
  data () {
    return {
      moneyType: [],
      loading: false
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {
    ...mapState({
      // moneyType: state => state.enumeration.moneyType
    })
  },
  methods: {
    getCurrencyList () {
      getCurrencyList().then((res) => {
        let { data } = res.data;
        let list = [];
        data.forEach((item) => {
          list.push({
            code: item.currencyCode,
            name: item.currencyName
          });
        });
        this.moneyType = list;
      });
    },
    changetaxType (val) {
      this.$nextTick(() => {
        // this.form.taxTypeName = this.$refs.taxType.selectedLabel;
        this.form.currencyName = this.$refs.taxType.selectedLabel;
      });
      this.$emit('changeTaxType', val);
    }
  },
  mounted () {
    this.getCurrencyList();
  }
};
</script>
<style lang="less"></style>
